enum MedicoRecebimentoTipoEnum {
    Material = 'material',
    Procedimento = 'procedimento',
    Exame = 'exame',
    Revisao = 'revisao'
}

export default MedicoRecebimentoTipoEnum
